import { SensorConfig, Sensors } from '../models/deviceState'
import { SensorPort, SensorType } from '../common/enums'
import {
  agridrain,
  badgermeter,
  battery,
  dwyer,
  paddlewheel,
  humidity,
  irrometer,
  pressure,
  rainfall,
  solarRadiation,
  genericSwitch,
  temperature,
  vegetronix,
  windDirection,
  windSpeed,
  aquaTroll500,
  counter,
  serviceCall,
} from '../converters'
import { SensorConfig1Message } from '../decoders'

export function extractSensorValue(
  sensor: SensorConfig,
  sensorValue: number,
  frequencyInMinutes: number
): number | undefined {
  if (
    sensor.sensorType !== SensorType.Unknown &&
    sensor.sensorType !== SensorType.None &&
    sensorValue !== 0xfff
  ) {
    const fn = {
      [SensorType.AgriDrain800770]: agridrain,
      [SensorType.Badgermeter220BR]: badgermeter,
      [SensorType.BadgermeterSDI]: badgermeter,
      [SensorType.Dwyer628]: dwyer,
      [SensorType.DEMPaddleWheel]: paddlewheel,
      [SensorType.Humidity]: humidity,
      [SensorType.IrrometerWM200SS]: irrometer,
      [SensorType.Pressure]: pressure,
      [SensorType.Rainfall]: rainfall,
      [SensorType.SolarRadiation]: solarRadiation,
      [SensorType.SwitchNormallyOpen]: genericSwitch,
      [SensorType.SwitchNormallyClosed]: genericSwitch,
      [SensorType.Temperature]: temperature,
      [SensorType.Battery]: battery,
      [SensorType.VegetronixVH400]: vegetronix,
      [SensorType.WindDirection]: windDirection,
      [SensorType.WindSpeed]: windSpeed,
      [SensorType.AquaTroll500DissolvedOxygenSensor]:
        aquaTroll500.dissolvedOxygen,
      [SensorType.AquaTroll500TurbiditySensor]: aquaTroll500.turbidity,
      [SensorType.AquaTroll500TotalDissolvedSolidsSensor]:
        aquaTroll500.totalDissolvedSolids,
      [SensorType.AquaTroll500NitrateSensor]: aquaTroll500.nitrates,
      [SensorType.AquaTroll500SpecificConductivitySensor]:
        aquaTroll500.specificConductivity,
      [SensorType.AquaTroll500SalinitySensor]: aquaTroll500.salinity,
      [SensorType.AquaTroll500TemperatureSensor]: aquaTroll500.temperature,
      [SensorType.CountButtonCB100]: counter,
      [SensorType.ServiceButtonSB100]: serviceCall,
      [SensorType.TiltSensorTS100]: counter,
    }[sensor.sensorType]

    if (fn) {
      return fn(
        sensorValue,
        sensor.conversion.scale,
        sensor.conversion.offset,
        frequencyInMinutes
      )
    }
  }
  return undefined
}

export function decodeSensor(
  currentSensorConfig: Sensors,
  sensorConfig: SensorConfig1Message
): Sensors {
  if (
    sensorConfig.sensorPort !== SensorPort.Unknown &&
    sensorConfig.sensorType !== SensorType.Unknown
  ) {
    const config: { [key: string]: SensorConfig } = {}

    config[sensorConfig.sensorPort] = {
      sensorType: sensorConfig.sensorType,
      units: sensorConfig.sensorUnits,
      conversion: {
        method: sensorConfig.conversionMethod,
        scale: sensorConfig.conversionScale,
        offset: sensorConfig.conversionOffset,
      },
      enabled: sensorConfig.flagSensorEnabled,
      thresholds: {
        configured: false,
        low: {
          value: -1,
          enabled: false,
          triggered: false,
        },
        high: {
          value: -1,
          enabled: false,
          triggered: false,
        },
        delta: {
          value: -1,
          enabled: false,
          triggered: false,
        },
      },
    }

    return {
      ...currentSensorConfig,
      ...config,
    }
  }

  return currentSensorConfig
}
